const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempProcesoEntrada", headerName: "Temp Proceso Entrada", minWidth: 180, flex: 1 },
  { field: "tempProcesoSalida", headerName: "Temp Proceso Salida", minWidth: 180, flex: 1 },
  { field: "condicionActualEquipo", headerName: "Condición Actual del Equipo", minWidth: 200, flex: 1 },
  { field: "modulo1Status", headerName: "Módulo 1 Status", minWidth: 150, flex: 1 },
  { field: "modulo2Status", headerName: "Módulo 2 Status", minWidth: 150, flex: 1 },
  { field: "modulo3Status", headerName: "Módulo 3 Status", minWidth: 150, flex: 1 },
  { field: "modulo4Status", headerName: "Módulo 4 Status", minWidth: 150, flex: 1 },
  { field: "modulo5Status", headerName: "Módulo 5 Status", minWidth: 150, flex: 1 },
  { field: "modulo6Status", headerName: "Módulo 6 Status", minWidth: 150, flex: 1 },
  { field: "modulo7Status", headerName: "Módulo 7 Status", minWidth: 150, flex: 1 },
  { field: "modulo8Status", headerName: "Módulo 8 Status", minWidth: 150, flex: 1 },
  { field: "modulo9Status", headerName: "Módulo 9 Status", minWidth: 150, flex: 1 },
  { field: "modulo10Status", headerName: "Módulo 10 Status", minWidth: 150, flex: 1 },
  { field: "m1CondicionComp1", headerName: "M1 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m1CondicionComp2", headerName: "M1 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m1TempEvapSalida", headerName: "M1 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m1TempEvapEntrada", headerName: "M1 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m1PresionDescargaComp1", headerName: "M1 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m1PresionDescargaComp2", headerName: "M1 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m1IDE", headerName: "M1 IDE", minWidth: 150, flex: 1 },
  { field: "m2CondicionComp1", headerName: "M2 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m2CondicionComp2", headerName: "M2 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m2TempEvapSalida", headerName: "M2 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m2TempEvapEntrada", headerName: "M2 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m2PresionDescargaComp1", headerName: "M2 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m2PresionDescargaComp2", headerName: "M2 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m2IDE", headerName: "M2 IDE", minWidth: 150, flex: 1 },
  { field: "m3CondicionComp1", headerName: "M3 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m3CondicionComp2", headerName: "M3 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m3TempEvapSalida", headerName: "M3 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m3TempEvapEntrada", headerName: "M3 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m3PresionDescargaComp1", headerName: "M3 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m3PresionDescargaComp2", headerName: "M3 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m3IDE", headerName: "M3 IDE", minWidth: 150, flex: 1 },
  { field: "m4CondicionComp1", headerName: "M4 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m4CondicionComp2", headerName: "M4 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m4TempEvapSalida", headerName: "M4 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m4TempEvapEntrada", headerName: "M4 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m4PresionDescargaComp1", headerName: "M4 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m4PresionDescargaComp2", headerName: "M4 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m4IDE", headerName: "M4 IDE", minWidth: 150, flex: 1 },
  { field: "m5CondicionComp1", headerName: "M5 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m5CondicionComp2", headerName: "M5 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m5TempEvapSalida", headerName: "M5 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m5TempEvapEntrada", headerName: "M5 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m5PresionDescargaComp1", headerName: "M5 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m5PresionDescargaComp2", headerName: "M5 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m5IDE", headerName: "M5 IDE", minWidth: 150, flex: 1 },
  { field: "m6CondicionComp1", headerName: "M6 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m6CondicionComp2", headerName: "M6 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m6TempEvapSalida", headerName: "M6 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m6TempEvapEntrada", headerName: "M6 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m6PresionDescargaComp1", headerName: "M6 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m6PresionDescargaComp2", headerName: "M6 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m6IDE", headerName: "M6 IDE", minWidth: 150, flex: 1 },
  { field: "m7CondicionComp1", headerName: "M7 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m7CondicionComp2", headerName: "M7 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m7TempEvapSalida", headerName: "M7 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m7TempEvapEntrada", headerName: "M7 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m7PresionDescargaComp1", headerName: "M7 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m7PresionDescargaComp2", headerName: "M7 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m7IDE", headerName: "M7 IDE", minWidth: 150, flex: 1 },
  { field: "m8CondicionComp1", headerName: "M8 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m8CondicionComp2", headerName: "M8 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m8TempEvapSalida", headerName: "M8 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m8TempEvapEntrada", headerName: "M8 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m8PresionDescargaComp1", headerName: "M8 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m8PresionDescargaComp2", headerName: "M8 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m8IDE", headerName: "M8 IDE", minWidth: 150, flex: 1 },
  { field: "m9CondicionComp1", headerName: "M9 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m9CondicionComp2", headerName: "M9 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m9TempEvapSalida", headerName: "M9 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m9TempEvapEntrada", headerName: "M9 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m9PresionDescargaComp1", headerName: "M9 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m9PresionDescargaComp2", headerName: "M9 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m9IDE", headerName: "M9 IDE", minWidth: 150, flex: 1 },
  { field: "m10CondicionComp1", headerName: "M10 Condición Comp 1", minWidth: 200, flex: 1 },
  { field: "m10CondicionComp2", headerName: "M10 Condición Comp 2", minWidth: 200, flex: 1 },
  { field: "m10TempEvapSalida", headerName: "M10 Temp Evap Salida", minWidth: 200, flex: 1 },
  { field: "m10TempEvapEntrada", headerName: "M10 Temp Evap Entrada", minWidth: 200, flex: 1 },
  { field: "m10PresionDescargaComp1", headerName: "M10 Presión Descarga Comp 1", minWidth: 250, flex: 1 },
  { field: "m10PresionDescargaComp2", headerName: "M10 Presión Descarga Comp 2", minWidth: 250, flex: 1 },
  { field: "m10IDE", headerName: "M10 IDE", minWidth: 150, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempProcesoEntrada: row["Temp Proceso Entrada"],
  tempProcesoSalida: row["Temp Proceso Salida"],
  condicionActualEquipo: row["Condicion Actual del Equipo"],
  modulo1Status: row["Módulo 1 Status"],
  modulo2Status: row["Módulo 2 Status"],
  modulo3Status: row["Módulo 3 Status"],
  modulo4Status: row["Módulo 4 Status"],
  modulo5Status: row["Módulo 5 Status"],
  modulo6Status: row["Módulo 6 Status"],
  modulo7Status: row["Módulo 7 Status"],
  modulo8Status: row["Módulo 8 Status"],
  modulo9Status: row["Módulo 9 Status"],
  modulo10Status: row["Módulo 10 Status"],
  m1CondicionComp1: row["M1 Condición Actual del Comp 1"],
  m1CondicionComp2: row["M1 Condición Actual del Comp 2"],
  m1TempEvapSalida: row["M1 Temp Evap Salida"],
  m1TempEvapEntrada: row["M1 Temp Evap Entrada"],
  m1PresionDescargaComp1: row["M1 Presión Descarga Comp 1"],
  m1PresionDescargaComp2: row["M1 Presión Descarga Comp 2"],
  m1IDE: row["IDE M1"],
  m2CondicionComp1: row["M2 Condición Actual del Comp 1"],
  m2CondicionComp2: row["M2 Condición Actual del Comp 2"],
  m2TempEvapSalida: row["M2 Temp Evap Salida"],
  m2TempEvapEntrada: row["M2 Temp_Evap_Ent"],
  m2PresionDescargaComp1: row["M2 Presión Descarga Comp 1"],
  m2PresionDescargaComp2: row["M2 Presión Descarga Comp 2"],
  m2IDE: row["IDE M2"],
  m3CondicionComp1: row["M3 Condición Actual del Comp 1"],
  m3CondicionComp2: row["M3 Condición Actual del Comp 2"],
  m3TempEvapSalida: row["M3 Temp Evap Salida"],
  m3TempEvapEntrada: row["M3 Temp_Evap_Ent"],
  m3PresionDescargaComp1: row["M3 Presión Descarga Comp 1"],
  m3PresionDescargaComp2: row["M3 Presión Descarga Comp 2"],
  m3IDE: row["IDE M3"],
  m4CondicionComp1: row["M4 Condición Actual del Comp 1"],
  m4CondicionComp2: row["M4 Condición Actual del Comp 2"],
  m4TempEvapSalida: row["M4 Temp Evap Salida"],
  m4TempEvapEntrada: row["M4 Temp_Evap_Ent"],
  m4PresionDescargaComp1: row["M4 Presión Descarga Comp 1"],
  m4PresionDescargaComp2: row["M4 Presión Descarga Comp 2"],
  m4IDE: row["IDE M4"],
  m5CondicionComp1: row["M5 Condición Actual del Comp 1"],
  m5CondicionComp2: row["M5 Condición Actual del Comp 2"],
  m5TempEvapSalida: row["M5 Temp Evap Salida"],
  m5TempEvapEntrada: row["M5 Temp_Evap_Ent"],
  m5PresionDescargaComp1: row["M5 Presión Descarga Comp 1"],
  m5PresionDescargaComp2: row["M5 Presión Descarga Comp 2"],
  m5IDE: row["IDE M5"],
  m6CondicionComp1: row["M6 Condición Actual del Comp 1"],
  m6CondicionComp2: row["M6 Condición Actual del Comp 2"],
  m6TempEvapSalida: row["M6 Temp Evap Salida"],
  m6TempEvapEntrada: row["M6 Temp_Evap_Ent"],
  m6PresionDescargaComp1: row["M6 Presión Descarga Comp 1"],
  m6PresionDescargaComp2: row["M6 Presión Descarga Comp 2"],
  m6IDE: row["IDE M6"],
  m7CondicionComp1: row["M7 Condición Actual del Comp 1"],
  m7CondicionComp2: row["M7 Condición Actual del Comp 2"],
  m7TempEvapSalida: row["M7 Temp Evap Salida"],
  m7TempEvapEntrada: row["M7 Temp_Evap_Ent"],
  m7PresionDescargaComp1: row["M7 Presión Descarga Comp 1"],
  m7PresionDescargaComp2: row["M7 Presión Descarga Comp 2"],
  m7IDE: row["IDE M7"],
  m8CondicionComp1: row["M8 Condición Actual del Comp 1"],
  m8CondicionComp2: row["M8 Condición Actual del Comp 2"],
  m8TempEvapSalida: row["M8 Temp Evap Salida"],
  m8TempEvapEntrada: row["M8 Temp_Evap_Ent"],
  m8PresionDescargaComp1: row["M8 Presión Descarga Comp 1"],
  m8PresionDescargaComp2: row["M8 Presión Descarga Comp 2"],
  m8IDE: row["IDE M8"],
  m9CondicionComp1: row["M9 Condición Actual del Comp 1"],
  m9CondicionComp2: row["M9 Condición Actual del Comp 2"],
  m9TempEvapSalida: row["M9 Temp Evap Salida"],
  m9TempEvapEntrada: row["M9 Temp_Evap_Ent"],
  m9PresionDescargaComp1: row["M9 Presión Descarga Comp 1"],
  m9PresionDescargaComp2: row["M9 Presión Descarga Comp 2"],
  m9IDE: row["IDE M9"],
  m10CondicionComp1: row["M10 Condición Actual del Comp 1"],
  m10CondicionComp2: row["M10 Condición Actual del Comp 2"],
  m10TempEvapSalida: row["M10 Temp Evap Salida"],
  m10TempEvapEntrada: row["M10 Temp_Evap_Ent"],
  m10PresionDescargaComp1: row["M10 Presión Descarga Comp 1"],
  m10PresionDescargaComp2: row["M10 Presión Descarga Comp 2"],
  m10IDE: row["IDE M10"],
});

export const fullServiceCoolingV3ConsultaConfig = {
  title: "Full Service Cooling V3",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecoolingv3/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "Full Service Cooling V3",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};  